import { Link } from '@inertiajs/react';
import { DataProvider } from '@/Components/DataContext.jsx';
import { ToastContainer } from 'react-toastify';
import React from 'react';

export default function NakedLayout({ children }) {
  const backText = window?.location?.pathname?.includes('/jobs') ? 'Exit' : 'Back';
  const backLink = window?.location?.pathname?.includes('/jobs') ? 'jobs' : 'builder';

  return (
    <DataProvider>
      <div className="min-h-screen flex flex-col sm:justify-center items-center pt-0 sm:pt-0 bg-white dark:bg-gray-900 md:bg-gray-100 md:dark:bg-gray-900">
        <div className="w-full sm:max-w-xl md:mt-6 px-6 py-4 bg-white dark:bg-gray-800 shadow-md overflow-hidden sm:rounded-lg">
          {children}
        </div>
        <div className="mt-10 text-gray-400 text-sm">
          <Link href={route(`${backLink}`)} className="underline">
            &lt;&lt; {backText}
          </Link>
        </div>
        <ToastContainer position="top-right" />
      </div>
    </DataProvider>
  );
}
